import Entity from 'utilities/Entity';
import Exercise from './exercise';

class Homework extends Entity {
    exercises() {
        return this.hasMany(Exercise);
    }
}

export default new Homework();
